export const styles = theme => ({
  emptyCell: {
    textAlign: 'center'
  }
})



// WEBPACK FOOTER //
// ./src/components/WaitingListTable/styles.js